module.exports = __webpack_public_path__ + "img/Frage5_768x1024.b20dec51.jpg";